"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormProperty = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _stores = require("../stores");

var _vueJsonView = require("vue-json-view");

require("./index.less");

var _property = _interopRequireDefault(require("./property.json"));

var _dec, _class, _class2, _descriptor, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FormProperty = (_dec = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {
    return [];
  }
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(FormProperty, _Vue);

  var _super = _createSuper(FormProperty);

  function FormProperty() {
    var _this;

    (0, _classCallCheck2.default)(this, FormProperty);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "propertyList", _descriptor, (0, _assertThisInitialized2.default)(_this));
    _this.store = _stores.store;
    return _this;
  }

  (0, _createClass2.default)(FormProperty, [{
    key: "onItemChange",
    value: function onItemChange(values) {
      var formProperty = this.store.formProperty;
      this.store.formProperty = _vueJsonView.Utils.setDataByObj(formProperty, values);
    }
  }, {
    key: "render",
    value: function render(h) {
      var formProperty = this.store.formProperty;
      var propertyList = [].concat((0, _toConsumableArray2.default)(_property.default), (0, _toConsumableArray2.default)(this.propertyList));
      return h("div", {
        "class": "form-property"
      }, [h("mh-form", {
        "attrs": {
          "layout": "vertical",
          "initData": formProperty
        },
        "on": {
          "itemChange": this.onItemChange
        }
      }, [propertyList.map(function (p) {
        return _vueJsonView.VueJsonView.ele2VNode(h, p, _stores.store);
      })])]);
    }
  }]);
  return FormProperty;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "propertyList", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.FormProperty = FormProperty;